import { useCallback, useEffect, useRef, useState } from 'react';
import { useReducedMotion } from 'framer-motion';

const CHARS = '!<>-_\\/[]{}=+*^?#ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

/* Terminal-style decode effect. trigger: "hover" | "mount" (scrambles once on mount/in-view) */
export default function ScrambleText({ text, trigger = 'hover', speed = 28, className, style, as: Tag = 'span' }) {
  const [display, setDisplay] = useState(text);
  const frameRef = useRef(null);
  const reduce = useReducedMotion();

  const scramble = useCallback(() => {
    if (reduce) return;
    if (frameRef.current) clearInterval(frameRef.current);
    let frame = 0;
    const total = text.length * 2.2;
    frameRef.current = setInterval(() => {
      frame++;
      const progress = frame / total;
      const settled = Math.floor(progress * text.length);
      let out = '';
      for (let i = 0; i < text.length; i++) {
        if (text[i] === ' ') { out += ' '; continue; }
        out += i < settled ? text[i] : CHARS[Math.floor(Math.random() * CHARS.length)];
      }
      setDisplay(out);
      if (frame >= total) {
        clearInterval(frameRef.current);
        setDisplay(text);
      }
    }, speed);
  }, [text, speed, reduce]);

  useEffect(() => {
    if (trigger === 'mount') scramble();
    return () => { if (frameRef.current) clearInterval(frameRef.current); };
  }, [trigger, scramble]);

  useEffect(() => setDisplay(text), [text]);

  return (
    <Tag
      className={className}
      style={style}
      aria-label={text}
      onMouseEnter={trigger === 'hover' ? scramble : undefined}
    >
      {display}
    </Tag>
  );
}
